<template>
  <div class="select-wings">
    <md-select
        :value="value"
        :md-class="mdClass"
        v-bind="$attrs"
        v-on="$listeners"
        @input="$emit('input',$event)"
        @md-closed="search = ''"
        name="select-wings">
      <div class="md-layout-item" v-if="searchField">
        <md-field class="mt10" :class="mdClass">
          <label>{{ $t("search") }}</label>
          <md-input type="text" v-model="search"></md-input>
        </md-field>
      </div>
      <slot :options="availableOptions">
        <md-option v-for="(option, index) in availableOptions" :value="option" :key="index">
          {{ option }}
        </md-option>
      </slot>
    </md-select>
    <md-button v-if="!$attrs.disableDelete && !$attrs.disabled && (value || typeof value === 'number') && (!Array.isArray(value) || value.length > 0)"
               v-bind="$attrs"
               :id="`button_reset_${$attrs.id}`"
               @click="$emit('input', 'multiple' in $attrs ? [] : null)"
               class="md-icon-button md-dense md-input-action md-clear md-theme-default">
      <md-icon>close</md-icon>
    </md-button>
    <md-tooltip v-show="mdTooltip !== undefined" :md-direction="mdTooltipDirection">{{ mdTooltip }}</md-tooltip>
  </div>
</template>

<script>
  export default {
    name: "Wings-Select",
    props:{
      options:{type:Array},
      value:{type:Array|String|Number},
      searchField:{type:String},
      valueField:{type:String},
      mdClass:{type:String},
      mdTooltip:{type:String},
      mdTooltipDirection:{type:String, default:'right'},
    },
    data(){return{
      search:''
    }},
    computed:{
      availableOptions(){
        if (!this.search) return this.options;
        if (!this.searchField){
          return this.options.filter(option => option.toLowerCase().includes(this.search.toLowerCase()));
        }
        let searchOptions = this.options.filter(option => option[this.searchField].toLowerCase().includes(this.search.toLowerCase()));
        if (this.valueField){
          let newOption = {};
          newOption[this.searchField] = this.search;
          newOption[this.valueField] = this.search;
          searchOptions.push(newOption)
        }

        return searchOptions;
      }
    }
  }
</script>

<style scoped>
  .select-wings{
    flex: 1;
    position:relative;
    max-width: 100%;
  }
  .select-wings__clear{
    position: absolute;
    right: 20px;
    bottom: 5px;
  }
</style>